import { useState, useEffect } from 'react';
import { useWhatsAppLead } from '@/hooks/useWhatsAppLead';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { openModal } = useWhatsAppLead();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'glass border-b border-gold/10 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <img
            src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/caaea5a1b17e64d200d3c08d14d4a01f.png"
            alt="Smart Hizmet Platform Logo"
            className="h-14 w-auto object-contain transition-all duration-300"
            style={{ filter: 'drop-shadow(0 0 10px rgba(240,180,41,0.35))' }}
          />
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: 'Sorun', id: 'problem' },
            { label: 'Çözüm', id: 'solution' },
            { label: 'Nasıl Çalışır', id: 'how-it-works' },
            { label: 'Özellikler', id: 'features' },
            { label: 'Paketler', id: 'packages' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-medium text-gray-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('demo-packages')}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-gold hover:text-yellow-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-eye-line text-xs" />
            Demo İncele
          </button>
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => scrollTo('packages')}
            className="btn-outline-neon px-5 py-2.5 rounded-lg text-sm cursor-pointer whitespace-nowrap"
          >
            Paketleri Gör
          </button>
          <button
            onClick={() => openModal('Header — Demo Talep Et')}
            className="btn-gold px-5 py-2.5 rounded-lg text-sm cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
          >
            <i className="ri-whatsapp-line" />
            Demo Talep Et
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-gray-300 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden glass border-t border-white/5 mt-2 px-4 py-4 flex flex-col gap-4">
          {[
            { label: 'Sorun', id: 'problem' },
            { label: 'Çözüm', id: 'solution' },
            { label: 'Nasıl Çalışır', id: 'how-it-works' },
            { label: 'Özellikler', id: 'features' },
            { label: 'Paketler', id: 'packages' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-medium text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('demo-packages')}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-gold hover:text-yellow-300 transition-colors cursor-pointer text-left"
          >
            <i className="ri-eye-line text-xs" />
            Demo İncele
          </button>
          <button
            onClick={() => { setMenuOpen(false); openModal('Mobil Menü — Demo Talep Et'); }}
            className="btn-gold px-5 py-3 rounded-lg text-sm cursor-pointer whitespace-nowrap w-full inline-flex items-center justify-center gap-2"
          >
            <i className="ri-whatsapp-line" />
            Demo Talep Et
          </button>
        </div>
      )}
    </header>
  );
}
